export default "__VITE_ASSET__Wzhmf8kI__"